import { ApiError } from './api'
import { PERMISSION_DENIED_MESSAGE } from './permissions'

const CURATED_403_CODES: Readonly<Record<string, string>> = {
  SELF_ASSIGNMENT: 'You can’t grant or promote your own access.',
  SELF_REVOCATION: 'You can’t revoke your own access.',
  ROLE_ESCALATION:
    'The role includes a protected permission you don’t hold at this entity.',
  SELF_IMPERSONATION: 'You can’t impersonate yourself.',
  IMPERSONATION_PROTECTED_GAP:
    'You can’t impersonate a user who holds a protected permission you don’t.',
  SYSTEM_ROLE_READ_ONLY: 'Built-in roles are read-only.',
  PROPOSAL_PERMISSION_CHANGED:
    'Your permissions for this proposal have changed since it was issued.',
  ENTITY_NOT_USER_MANAGEMENT_ENTITY:
    'Groups can only be created at a user management entity.',
  INVITATION_MANAGE_SCOPE:
    'This invitation also grants access outside the entities you manage; an administrator with that scope must manage it.',
}

export function apiErrorMessage(
  error: unknown,
  fallback: string,
  options?: { codes?: Readonly<Record<string, string>> },
): string {
  if (!(error instanceof ApiError)) return fallback
  if (error.code) {
    const curated =
      error.status === 403 ? CURATED_403_CODES[error.code] : undefined
    const mapped = options?.codes?.[error.code] ?? curated
    if (mapped) return mapped
  }
  if (error.status === 403) return PERMISSION_DENIED_MESSAGE
  return fallback
}
